export const styles = theme => ({
    xtraLarge: {
        width: '160px',
        height: '160px'
    }
});
